import React, { Component } from 'react'
import { Result } from 'antd'
import { PermissionResult } from '../../../helpers/permission-checker.helper'

export enum CheckType {
  list = 'list',
  create = 'create',
  edit = 'save',
  delete = 'delete'
}

export type ViewComponentProps = {
  permissions: PermissionResult,
  check: CheckType | 'list' | 'create' | 'edit' | 'delete'
}

export default class ViewComponent extends Component<ViewComponentProps> {
  render() {
    const { permissions, check, children } = this.props
    const permissionType = CheckType[check]
    
    if (!permissions[permissionType]) {
      return (
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
        />
      )
    }

    return children
  }
}
